import { authenticate } from "@/api/index";
import { fetchContractorList, fetchContractList } from "@/api/admin";
const actions = {
  SET_NAV_INDEX({ commit }, data) {
    commit("SET_NAV_INDEX", data);
  },
  LOGIN({ commit }, data) {
    commit("LOGIN", data);
  },
  LOGOUT({ commit }) {
    document.location.href = "/";
    commit("RESET");
    commit("LOGOUT");
  },
  SET_USER_INFO({ commit }, data) {
    commit("SET_USER_INFO", data);
  },
  getAccountInfo({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      authenticate()
        .then((res) => {
          if (res.status === 200) {
            let data = {
              email: res.data.email,
              name: res.data.name,
              role: res.data.role,
              service: res.data.distribution_service,
              menu: res.data.distribution_menu,
            };
            commit("SET_USER_INFO", data);
            resolve(data);
          } else {
            dispatch("LOGOUT");
            reject(new Error("Failed to get account info"));
          }
        })
        .catch((error) => {
          dispatch("LOGOUT");
          reject(error);
        });
    });
  },
  SET_LNB_VISIBLE({ commit }, data) {
    commit("SET_LNB_VISIBLE", data);
  },
  SET_GNB_VISIBLE({ commit }, data) {
    commit("SET_GNB_VISIBLE", data);
  },
  SET_FOOTER_VISIBLE({ commit }, data) {
    commit("SET_FOOTER_VISIBLE", data);
  },
  SET_PAGENAME({ commit }, data) {
    commit("SET_PAGENAME", data);
  },
  getContractorList({ commit }, params) {
    fetchContractorList(params).then((res) => {
      if (res.data.code == 1000) {
        commit("SET_CONTRACTOR_LIST", res.data.data);
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "확인",
          center: true,
        });
      }
    });
  },
  getContractsByContractor({ commit }, params) {
    fetchContractList(params).then((res) => {
      if (res.data.code == 1000) {
        commit("SET_CONTRACT_LIST_BY_CONTRACTOR", res.data.data);
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "확인",
          center: true,
        });
      }
    });
  },
};

export default actions;
